import { useState } from "react";
import { useFormik } from "formik";
import { Link, Redirect } from "react-router-dom";
import { setUsernameAndPassword } from "../_redux/authCrud";

const initialValues = {
  username: "",
  password: "",
  passwordConfirm: ""
};

export default function UsernameAndPasswordSet(props) {
  const { intl } = props;
  const { authData } = props;
  const { isInvalid } = authData;
  const [isRequested, setIsRequested] = useState(false);
  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    // validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setValues, setStatus, setSubmitting }) => {
      const passwordData = {
        domain: authData.domain,
        token: authData.token,
        username: values.username,
        newPassword: values.password,
        newPasswordConfirm: values.passwordConfirm
      };
      setUsernameAndPassword(passwordData)
      .then(({ data: {
        isSuccess,
        type,
        message
      }}) => {
        if (type === "error") type = "danger";
        setValues(type);
        setStatus(message);
        if (isSuccess) setTimeout(() => setIsRequested(true), 6000);
      })
      .catch(() => {
        setIsRequested(false);
        setStatus(
          intl.formatMessage(
            { id: "AUTH.VALIDATION.NOT_FOUND" },
            { name: values.email }
          )
        );
      })
      .finally(() => {
        setSubmitting(false);
      });
    },
  });

  return (
    <>
      {isInvalid && <Redirect to="/sifremi-unuttum" />}
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-set" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">
              {authData.schoolName}
            </h3>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status ? (
              <div className={`mb-10 alert alert-custom alert-light-${formik.values} alert-dismissible`}>
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            ) : (
              <div className="mb-10 alert alert-custom alert-light-info alert-dismissible">
                <div className="alert-text ">
                  Lütfen yeni <strong> kullanıcı adı</strong> ve <strong>şifrenizi</strong> giriniz.
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container">
              <input
                type="text"
                placeholder="Yeni Kullanıcı Adı"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "username"
                )}`}
                name="username"
                {...formik.getFieldProps("username")}
              />
              {formik.touched.username && formik.errors.username ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.username}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group fv-plugins-icon-container">
              <input
                type="password"
                placeholder="Yeni Şifre"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group fv-plugins-icon-container">
              <input
                type="password"
                placeholder="Yeni Şifre Tekrar"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "passwordConfirm"
                )}`}
                name="passwordConfirm"
                {...formik.getFieldProps("passwordConfirm")}
              />
              {formik.touched.passwordConfirm && formik.errors.passwordConfirm ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.passwordConfirm}</div>
                </div>
              ) : null}
            </div>
            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_set_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                {!formik.isSubmitting && <span>Kaydet</span>}
                {
                  formik.isSubmitting && 
                  <>
                    <span>Kaydediliyor</span>
                    <span className="ml-3 spinner spinner-white"></span>
                  </>
                }
              </button>
              <Link to="/auth">
                <button
                  type="button"
                  id="kt_login_sett_cancel"
                  className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
                >
                  Geri
                </button>
              </Link>
            </div>
          </form>
        </div>
      )}
    </>
  );
}